import { observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsAncillaryType, FlightsInformationSupportedAncillaryInfo } from '__generated__/api';
import FlightsSupportedAncillaries = FlightsInformationSupportedAncillaryInfo.Fragment;

export class FlightsSupportedAncillariesStore extends Store {
  @observable public flightsSupportedAncillaries: FlightsSupportedAncillaries;
  @observable public selectedAncillaryType: FlightsAncillaryType;
  @observable public selectedAncillaryId: string;
  @observable public selectedAncillariesMap: Map<FlightsAncillaryType, string> = new Map();

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

FlightsSupportedAncillariesStore.DEFAULTS = {
  flightsSupportedAncillaries: {
    journeyContinuationId: null,
    ancillaryTypes: null
  },
  selectedAncillaryType: null,
  selectedAncillaryId: null
};
